module.exports = __webpack_public_path__ + "img/saur-recommande-homeserve.759d6329.svg";